<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    optionsFont: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<template>
  <div class="wrap-select-font">
    <span class="label">フォント</span>
    <div class="select-font-wrap">
      <select
        class="select-font"
        :value="value"
        @input="$emit('input', $event.target.value)"
      >
        <option
          v-for="item in optionsFont"
          :key="item.value"
          class="select-item"
          :class="item.classFont"
          :value="item.value"
        >
          {{ item.label }}(英数字のみ)
        </option>
      </select>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import './select-font.scss';
</style>
